module.exports = __webpack_public_path__ + "src/assets/img/guest_bar.f0a74dc8.jpg";